import PropTypes from 'prop-types';
import CommonDialog from '../../shared/dialog/CommonDialog';
import css from '../account-settings.module.scss';
import CannotDeleteDeviceContent from './CannotDeleteDeviceContent';

const CannotDeleteDeviceDialog = ({ shouldShow, handleClose }) => (
  <CommonDialog
    data-testid="cannotDeleteDeviceDialog"
    dialogOpen={shouldShow}
    handleDialogClose={handleClose}
    classNames={{
      body: css.dialogBody,
      content: css.dialogContent,
    }}
    closeButtonProps={{ className: css.closeIcon }}
    preventOverlayClose
  >
    <CannotDeleteDeviceContent />
  </CommonDialog>
);

CannotDeleteDeviceDialog.propTypes = {
  shouldShow: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default CannotDeleteDeviceDialog;
